import { Injectable } from "@angular/core";
import { toBoolean } from "@obg/ngx.global";
import { forEach, head, map as lodashMap, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ContentClient } from "../content/content.client";
import { ContentDocument } from "../content/content.model";

import { Quicklink, QuicklinkResponse } from "./quicklink.model";

/**
 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class QuicklinkService {
	constructor(private client: ContentClient) {}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	get(): Observable<Record<string, Quicklink[]>> {
		return this.client.getQuicklinks().pipe(
			map((response) => {
				const quicklinks: Record<string, Quicklink[]> = {};
				forEach(response.documents, (rawQuicklinks, quicklinkType) => {
					quicklinks[quicklinkType] = lodashMap(rawQuicklinks, this.processRawQuicklinks);
				});
				return quicklinks;
			})
		);
	}

	private processRawQuicklinks(rawQuicklink: ContentDocument<QuicklinkResponse>): Quicklink {
		const metadata = rawQuicklink.content.metadata;

		return {
			documentKey: rawQuicklink.documentKey,
			label: {
				text: rawQuicklink.content.label
					? unescape(head(rawQuicklink.content.label))
					: unescape(head(rawQuicklink.content.title)),
			},
			image: head(rawQuicklink.content.image),
			iconTag: head(rawQuicklink.content.iconTag),
			link: head(rawQuicklink.content.link)!,
			route: head(rawQuicklink.content.route),
			userState: metadata?.userState ?? [],
			jurisdiction: metadata?.jurisdiction ?? [],
			commandName: metadata?.commandName?.[0],
			large: toBoolean(head(metadata?.large)) ?? false,
			secondaryLabel: head(rawQuicklink.content.secondaryLabel),
			enableColouredIcon: toBoolean(head(metadata?.colouredIcon)) ?? false,
			colouredIcon: head(rawQuicklink.content.colouredIcon),
		};
	}
}
